import React, { useContext, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import Box from '@mui/material/Box'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'

import { dateFormatFunction } from '@/custom/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LinearProgress } from '@mui/material'
import Loaders from '../../molecules/Loaders'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AuctionContext from '@/product/context/auction/auctionContext'
import BaseActionPage from '@/custom/components/organisms/Product/BaseActionPages'
import ProductContext from '@/product/context/product/productContext'
import AuthContext from '@/product/context/auth/authContext'
import AsinContext from '@/product/context/thirdParty/asin/asinContext'
import HomeContext from '@/product/context/thirdParty/homeDepot/homeContext'
import XBarContext from '@/product/context/thirdParty/xBarCode/xbarContext'
import TemplateContext from '@/product/context/template/product/productContext'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import { useTranslation } from 'react-i18next'
import { findAllByDisplayValue } from '@testing-library/dom'
import ControlHubContext from '@/product/context/controlHub/controlHubContext'
import { useHistory } from 'react-router-dom'
import commonContext from '@/product/context/common/commonContext'
import ManifestContext from '@/product/context/manifest/manifestContext'
import settingContext from '@/custom/context/setting/settingContext'

let randomVariable = Math.random()

const ProductFieldsView = (props) => {
    const productContext = useContext(ProductContext)
    const manifestContext = useContext(ManifestContext)
    const auctionContext = useContext(AuctionContext)
    const history = useHistory()

    const [charityData, setCharityData] = useState([])
    const settingContexts = useContext(settingContext)
    const { getAllGlobalData, all_global_data, getMatchWonProductPrice } =
        settingContexts
    const settingcontext = useContext(SettingContext)
    const dashboardContext = useContext(commonContext)
    const { getMainDashboardData } = dashboardContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const { t } = useTranslation()
    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const {
        single_manifest,
        getSingleManifest,
        responseStatus: responseStatusManifest,
        clearResponse: clearResponseManifest,
    } = manifestContext

    const {
        projectAction,
        single_project,
        getSingleProject,
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext

    const {
        all_auctions,
        getAllAuctions,
        assignAuctionLot,
        responseStatus: responseStatusAuction,
    } = auctionContext
    const { getGlobalVariable, alldata_all_dropdown, allLocations } =
        useContext(CustomCommonContext)
    const authContext = useContext(AuthContext)
    const asinContext = useContext(AsinContext)
    const homeContext = useContext(HomeContext)
    const xbarContext = useContext(XBarContext)
    const controlHubContext = useContext(ControlHubContext)
    const { getTableDataDynamic, table_data } = controlHubContext
    const { user } = authContext
    const {
        responseStatus: responseHomeDepot,
        all_products: homedepot_products,
        retrieveProduct: retrieveHomeDepot,
        clearResponse: clearResponseHomeDepot,
    } = homeContext

    const {
        responseStatus: responseHomeXBar,
        all_products: xbar_products,
        retrieveProduct: retrieveXBarCode,
        clearResponse: clearResponseXBar,
    } = xbarContext

    const {
        single_project: template_SingleValue,
        getSingleProject: template_GetSingleValue,
    } = useContext(TemplateContext)

    const {
        responseStatus: responseAsin,
        all_products,
        retrieveProduct,
        clearResponse: clearResponseAsin,
    } = asinContext
    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [asinDetails, setAsinDetails] = useState({})
    const [update, setUpdate] = useState(false)
    const [buttonData, setButtonData] = useState([])
    const [singleManifest, setSingleManifest] = useState({})
    const [allautiondetails, setAllauctions] = useState([])
    const [pluginCountDetails, setPluginCountDetails] = useState(null)
    const [mapDataValue, setMapDataValue] = useState([])
    const [fieldData, setFieldData] = useState([])
    const [pluginType, setPluginType] = useState('')
    const [formikValues, setFormikValues] = useState({})
    const [asinValue, setAsinValue] = useState({ record: {} })
    const [propsFieldValue, setPropsFieldValue] = useState([])
    const [singleProject, setSingleProject] = useState({ record: {} })
    const [filterCharity, setFilterCharity] = useState({})

    const mapDataValueRef = useRef(mapDataValue)
    let showPluginCount = global?.showPluginCount
        ? global.showPluginCount
        : props?.showPluginCount
        ? props.showPluginCount
        : []
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])

    useEffect(() => {
        let projectDynamicArray = props.fieldValue.filter(
            (data) =>
                data.name !== 'asin' &&
                data.name !== 'home_depot' &&
                data.name !== 'upc_id' &&
                data.name !== 'x_barcode' &&
                data.active === 1
        )

        if (props.data?.status === 'new') {
            resetFormikAsin()
            resetFormikHome()
            resetFormikUpc()
            resetFormikXBar()
        } else {
            projectDynamicArray.push({
                name: 'wprice',
                value: '',
                type: 'default',
                active: 1,
            })
        }

        setPropsFieldValue(projectDynamicArray)
    }, [props.fieldValue, props.data])

    useEffect(() => {
        if (responseAsin && responseAsin.from === randomVariable) {
            if (responseAsin.status === 'error') {
                setIsLoading(false)
                clearResponseAsin()
            }
        }
    }, [responseAsin])

    useEffect(() => {
        if (props?.loading === true || props?.loading === false) {
            setIsLoading(props?.loading)
        }
    }, [props?.loading])

    useEffect(() => {
        if (showPluginCount.length) {
            if (table_data && table_data.records && table_data.records.length) {
                let showData = {}
                table_data.records.map((ele) => {
                    if (ele.payments) {
                        if (showPluginCount.includes(ele.name)) {
                            showData[ele.name] = {
                                limit: ele.max_limit ? ele.max_limit : 0,
                                used: ele.use_count ? ele.use_count : 0,
                                balance: ele.enable
                                    ? ele.max_limit - ele.use_count
                                    : 0,
                                enable: ele.enable,
                                percent: (ele.use_count / ele.max_limit) * 100,
                            }
                        }
                    }
                })
                setPluginCountDetails(showData)
            }
        }
    }, [table_data])
    useEffect(() => {
        if (showPluginCount.length && data?.popup) {
            setPluginCountDetails(null)
            if (props.data?.status === 'new') {
                getTableDataDynamic()
            }
        }
    }, [data?.popup])
    useEffect(() => {
        let customValidationTemp = {}
        let customInitial = {
            id: 0,
            market_status: 'open',
            auctiontype: 'live',
            title: '',
            delivery_available_country: [],
            listing_type: props?.initialId ? props.initialId : '',
        }
        if (props.customInitialValues) {
            customInitial = { ...customInitial, ...props.customInitialValues }
        }

        customValidationTemp = {
            selltype: Yup.boolean(),
            selectedbuyer: Yup.array().when('selltype', {
                is: (avatar) => avatar,
                then: Yup.array().required('Required!'),
            }),
            date_added: Yup.date()
                .transform((__, value) => {
                    if (!value) return null

                    const parsed = moment(
                        value,
                        'DD-MM-YYYY h:mm a',
                        true
                    ).subtract(1, 'minutes')
                    return parsed.isValid() ? parsed.toDate() : null
                })
                .nullable()
                .typeError(t('Please enter valid Date!'))
                .required(t('Required!')),

            title: Yup.string().nullable(),
            date_closed: Yup.date()
                .transform((__, value) => {
                    if (!value) return null

                    // Parse using your expected format
                    const parsed = moment(value, 'DD-MM-YYYY h:mm a', true)
                    return parsed.isValid() ? parsed.toDate() : null
                })
                .nullable()
                .typeError(t('Please enter a valid Date!'))
                .min(new Date(), t('Date must be in the future!')) // Ensures it's greater than current datetime
                .required(t('Required!')),
            // date_closed: Yup.date(t('Please enter valid Date!'))
            //     .transform((__, value) =>
            //         value && typeof value === 'string'
            //             ? new Date(
            //                   moment(
            //                       value,
            //                       global.defaultDateTimeFormat ||
            //                           'MM-DD-YYYY h:mm a'
            //                   ).toDate()
            //               )
            //             : new Date(moment(value).toDate())
            //     )
            //     .nullable()
            //     .typeError(t('Required!'))
            //     .min(new Date(), t('Date must be in the future!')) // ✅ Must be after now
            //     .min(
            //         Yup.ref('date_added'),
            //         t('Should be greater than start Time')
            //     ) //
            //     .required(t('Required!')),

            i_agree_to_postsale_agreement: Yup.boolean()
                .oneOf([true], t('You must agree to the post-sale agreement')) // Ensures the checkbox is checked
                .required(t('Required!')),

            sprice: Yup.number()
                .integer('Price must be a whole number')
                .min(1, 'The minimum start price is 1')
                .moreThan(-1) // Ensures the price is greater than -1 (positive number)
                .nullable(false) // Allows null if the field is left empty
                .required(t('Required!')), // Optional: make it required if needed

            // rprice: Yup.number().when(['sprice'], {
            //     is: (sprice) => sprice && sprice > 0,
            //     then: Yup.number()
            //         .positive('Should be greater than 1')
            //         .required('Required!')
            //         .min(
            //             Yup.ref('sprice'),
            //             'Should be equal or greater than the starting price'
            //         ),
            //     otherwise: Yup.number(),
            // }),
            delivery_not_available: Yup.string().when('delivery_to', {
                is: '320',
                then: (schema) =>
                    schema.required('Countries to exclude are required'),
                otherwise: (schema) => schema.notRequired(),
            }),

            delivery_available_country: Yup.string().when('delivery_to', {
                is: '395',
                then: (schema) =>
                    schema.required('Countries to include are required'),
                otherwise: (schema) => schema.notRequired(),
            }),

            rprice: Yup.number()
                .integer('Price must be a whole number')
                .nullable()
                .when('sprice', (sprice, schema) => {
                    if (sprice && sprice > 0) {
                        return schema.test({
                            name: 'rprice-gte-sprice',
                            message:
                                'Reserve price should be equal or greater than starting price',
                            test: (rprice) => {
                                if (
                                    rprice === undefined ||
                                    rprice === null ||
                                    rprice === '' ||
                                    rprice === 0
                                ) {
                                    // not required, so empty is valid
                                    return true
                                }
                                return rprice >= sprice
                            },
                        })
                    }
                    return schema // no validation if sprice is not > 0
                }),
            // serial_number: Yup.string()
            //     .matches(/^\d+$/, t('Only numeric characters are allowed'))
            //     .required(t('Required!')),
            bprice: Yup.number().when('buynow', {
                is: true, // If 'buynow' is true, apply the validation below
                then: Yup.number()
                    .integer('Price must be a whole number')
                    .moreThan(-1) // Ensure the price is greater than -1
                    .required(t('Required!')) // Mark it as required if 'buynow' is true
                    .moreThan(
                        // Ensure the buy now price is greater than the reserve price
                        Yup.ref('sprice'),
                        t(
                            'The Buy Now price must be greater than the start price'
                        )
                    ),
            }),
            year: Yup.string()
                .nullable()
                .when('maker_country', (maker_country, schema) => {
                    return maker_country?.trim() === 'Cuba'
                        ? schema.required(t('Required!'))
                        : schema
                }),
            add_uv_image: Yup.string()
                .nullable()
                .when(
                    ['uv_image_year', 'year', 'maker_country'],
                    (uv_image_year, year, maker_country, schema) => {
                        const isCuba = maker_country?.trim() === 'Cuba'
                        const isRequired =
                            isCuba &&
                            uv_image_year &&
                            Number(uv_image_year) <= Number(year)
                        return isRequired
                            ? schema.required(
                                  t('A UV image is required for this box.')
                              )
                            : schema
                    }
                ),

            // add_uv_image: Yup.string()
            //     .nullable()
            //     .when(
            //         ['uv_image_year', 'year'],
            //         (uv_image_year, year, schema) => {
            //             const isRequired =
            //                 uv_image_year &&
            //                 Number(uv_image_year) <= Number(year)
            //             return isRequired
            //                 ? schema.required(
            //                       t('A UV image is required for this box.')
            //                   )
            //                 : schema
            //         }
            //     ),

            item: Yup.string().required(t('Required!')),
            maker: Yup.string().required(t('Required!')),
            maker_country: Yup.string().required(t('Required!')),
            cigar_country: Yup.string().required(t('Required!')),
            // number_of_item_for_sale: Yup.string().required(t('Required!')),
            // current_number_of_cigars_in_box: Yup.string().required(
            //     t('Required!')
            // ),
            cigar_source: Yup.string().required(t('Required!')),
            source_location: Yup.string().required(t('Required!')),
            storage_conditions: Yup.string()
                .required(t('Required!')) // Required validation with your translation function
                .max(200, t('Must be at most 200 characters!')),

            qty: Yup.number()
                .integer("Can't be a decimal")
                .required(t('Required!'))
                .positive(t('Should be greater than 0')),

            // location_id: Yup.string().when('local_pickup_check', {
            //     is: true,
            //     then: Yup.string().required(t('Required!')),
            // }),

            ...props.customValidation,
        }
        setCustomInitialValues(customInitial)
        setCustomValidation(customValidationTemp)
    }, [propsFieldValue, props.customValidation])

    useEffect(() => {
        if (formikValues?.rprice) {
            setCustomValidation({
                ...customValidation,
                bprice: Yup.number().when('buynow', {
                    is: true, // If 'buynow' is true, apply the validation below
                    then: Yup.number()
                        .integer('Price must be a whole number')
                        .moreThan(-1) // Ensure the price is greater than -1
                        .required(t('Required!')) // Mark it as required if 'buynow' is true
                        .moreThan(
                            // Ensure the buy now price is greater than the reserve price
                            Yup.ref('rprice'),
                            t(
                                'The Buy Now price must be greater than the reserve price'
                            )
                        ),
                }),
            })
        } else if (formikValues?.sprice) {
            setCustomValidation({
                ...customValidation,
                bprice: Yup.number().when('buynow', {
                    is: (buynow) => buynow == 234, // Check if 'buynow' equals 234
                    then: Yup.number()
                        .integer('Price must be a whole number')
                        .moreThan(-1)
                        .moreThan(
                            Yup.ref('sprice'),
                            t(
                                'The Buy Now price must be greater than the start price'
                            )
                        )
                        .required(t('Required!')),
                    otherwise: Yup.number(), // No additional validation if 'buynow' is not 234
                }),
            })
        }
    }, [formikValues?.rprice])

    useEffect(() => {
        let data = charityData.filter((el) => el.id == formikValues?.user_id)
        if (formikValues.user_id && data[0]?.emp_email) {
            searchTableFetch(
                {
                    page: 1,
                    limit: 1,
                    order: '',
                    orderby: '',
                    filters: {
                        user_id: {
                            value: data[0]?.emp_email,
                            type: 'in',
                            field: 'u.email',
                        },
                    },
                    primaryTable: 'users',
                },
                'users'
            )
        }
    }, [charityData, formikValues.user_id])

    useEffect(() => {
        if (search_fetch_data.from === 'users') {
            formikValues.seller_id = search_fetch_data.records[0]?.id
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            let projectValue = {}
            let projectType = 'edit'
            if (
                props.data &&
                props.data?.status &&
                props.data.status === 'edit'
            ) {
                projectValue = single_project.record
                    ? single_project.record
                    : {}
                projectType = 'edit'
            }

            if (
                props.data &&
                props.data?.status &&
                props.data.status === 'manifest'
            ) {
                projectValue = singleManifest.record
                    ? singleManifest.record
                    : {}
                projectType = 'manifest'
            }

            tempMapData.map((mapValue) => {
                if (
                    props?.customDisableFields?.length &&
                    props?.customDisableFields.includes(mapValue?.name) &&
                    projectValue?.bidscount
                ) {
                    mapValue.disabled = true
                }
                if (mapValue.name === 'date_closed') {
                    // mapValue.minDate = dateTimeFormatFunction(
                    //     formikValues.date_added ? formikValues.date_added : null
                    // )
                    mapValue.minDate = formikValues.date_added
                        ? formikValues.date_added
                        : null
                    mapValue.minDateMessage = `Date should not be before minimal date ${
                        formikValues.date_added ? formikValues.date_added : null
                    }`

                    // mapValue.minDateMessage = `Date should not be before minimal date ${dateTimeFormatFunction(
                    //     formikValues.date_added ? formikValues.date_added : null
                    // )}`
                    mapValue.disablePast = true
                } else if (mapValue.name === 'date_added') {
                    // mapValue.disablePast = true

                    mapValue.minDate = new Date()
                } else if (mapValue.name === 'number_of_item_for_sale') {
                    let val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues?.listing_type
                    )

                    mapValue.disabled =
                        val[0]?.description?.toLowerCase() ==
                        'multi item listing'
                            ? false
                            : true
                }
                if (mapValue.name === 'year') {
                    if (formikValues.maker_country != 'Cuba') {
                        formikValues.year = ''
                        mapValue.disabled = true
                    } else {
                        mapValue.disabled = false
                    }
                }
                if (mapValue.name === 'box_code') {
                    if (formikValues.maker_country != 'Cuba') {
                        formikValues.box_code = ''
                        mapValue.disabled = true
                    } else {
                        mapValue.disabled = false
                    }
                }
                if (mapValue.name === 'serial_number') {
                    if (formikValues.maker_country != 'Cuba') {
                        formikValues.serial_number = ''
                        mapValue.disabled = true
                    } else {
                        mapValue.disabled = false
                    }
                } else if (mapValue.name === 'description_year') {
                    mapValue.class = `${
                        formikValues?.year == 'Unknown Year' ? ' ' : 'd-none'
                    } col-sm-12 col-12`
                } else if (mapValue.name === 'add_uv_image') {
                    mapValue.class = 'col-sm-12 col-12'
                    // mapValue.class = `${
                    //     formikValues?.uv_image_year
                    //         ? formikValues?.uv_image_year <= formikValues?.year
                    //             ? ' '
                    //             : 'd-none'
                    //         : 'd-none'
                    // } col-sm-12 col-12`
                } else if (mapValue.name === 'delivery_available_country') {
                    let val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues?.delivery_to
                    )
                    mapValue.class = `${
                        val[0]?.description?.toLowerCase() ==
                        'allowed delivery preferences'
                            ? ' '
                            : 'd-none'
                    } col-sm-12 col-12`
                } else if (mapValue.name === 'delivery_not_available') {
                    let val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues?.delivery_to
                    )

                    mapValue.class = `${
                        val[0]?.description?.toLowerCase() ==
                        'not allowed delivery preferences'
                            ? ' '
                            : 'd-none'
                    } col-sm-12 col-12`
                } else if (mapValue.name === 'number_of_cigars_remaining') {
                    let val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues?.listing_type
                    )

                    mapValue.disabled =
                        val[0]?.description?.toLowerCase() ==
                        'partial box listing'
                            ? false
                            : true
                } else if (mapValue.name === 'bprice') {
                    mapValue.disabled = formikValues.buynow ? false : true
                } else if (mapValue.name === 'selectedbuyer') {
                    mapValue.disabled = formikValues.selltype ? false : true
                } else if (props.isBrilliant) {
                    if (mapValue.name === 'deposit_amount') {
                        mapValue.disabled = formikValues.deposit ? false : true
                        mapValue.label = 'Deposit Points'
                        mapValue.placeholder = 'Enter Deposit Points'
                    }
                } else if (mapValue.name === 'dimension_length') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'origin_zip') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_dates') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_start_hour') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_end_hour') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_appt_per_slot') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_slot_timeframe') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'station_package_code') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'station_warehouse') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (
                    global?.shopify &&
                    mapValue.name == 'push_to_shopify'
                ) {
                    mapValue.class = `${
                        formikValues.shopify_id ? 'd-none' : ''
                    } col-sm-6 col-6`
                } else if (
                    global?.ebay_listing &&
                    mapValue.name == 'push_to_ebay'
                ) {
                    mapValue.class = `col-sm-6 col-6`
                }

                if (mapValue.name === 'vehculo_nacionalpdf') {
                    const val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues.accidents
                    )
                    if (val[0]?.description == 'Si') {
                        mapValue.class = 'col-sm-3 col-12'
                        mapValue.disabled = false
                    } else {
                        mapValue.class = 'col-sm-3 col-12 invisible'
                        mapValue.disabled = true
                    }
                }
                if (mapValue.name === 'maintanace_historypdf') {
                    const val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues.maintenance_historysino
                    )
                    mapValue.class = `${
                        val[0]?.description == 'Si'
                            ? ''
                            : 'disabledDropzone invisible'
                    } col-sm-3 col-12`
                }
                if (mapValue.name == 'retail_price' && !global?.showRetail) {
                    mapValue.disabled = true
                }
                if (mapValue.name === 'source_description') {
                    mapValue.disabled = true
                    formikValues.source_description = 'Contact Seller'
                    mapValue.class = `${
                        formikValues.cigar_source == 'Other' ? '' : 'd-none'
                    } col-sm-12 col-12`
                }

                if (props.toggleAuctionAndBuynow) {
                    const val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues.select_product_type
                    )
                    if (mapValue.name === 'auction') {
                        mapValue.disabled = formikValues.buynow ? true : false
                    } else if (mapValue.name === 'buynow') {
                        mapValue.disabled = formikValues.auction ? true : false
                    }
                    if (mapValue.name === 'sprice') {
                        if (val[0]?.description == 'Habilitar Subasta') {
                            formikValues.auction = 1
                            mapValue.disabled = false
                        } else {
                            formikValues.auction = 0
                            mapValue.disabled = true
                        }
                        // formikValues.sprice = formikValues.buynow
                        //     ? ''
                        //     : formikValues.sprice
                    }

                    if (mapValue.name === 'rprice') {
                        if (val[0]?.description == 'Habilitar Subasta') {
                            formikValues.auction = 1
                            mapValue.disabled = false
                        } else {
                            formikValues.auction = 0
                            mapValue.disabled = true
                        }
                    }
                    if (mapValue.name === 'bprice') {
                        if (val[0]?.description == 'Habilitar Venta directa') {
                            formikValues.buynow = 1
                            mapValue.disabled = false
                        } else {
                            formikValues.buynow = 0
                            mapValue.disabled = true
                        }
                    }
                    if (mapValue.name == 'tire_manufacturer_spare') {
                        const val = alldata_all_dropdown.filter(
                            (e) => e.id == formikValues.spare_tire
                        )
                        mapValue.disabled =
                            val[0]?.description == 'Si' ? false : true
                        mapValue.class = `${
                            val[0]?.description == 'Si' ? '' : 'invisible'
                        } col-sm-3 col-12`
                    }
                    if (mapValue.name == 'tire_size_spare') {
                        const val = alldata_all_dropdown.filter(
                            (e) => e.id == formikValues.spare_tire
                        )
                        mapValue.disabled =
                            val[0]?.description == 'Si' ? false : true
                        mapValue.class = `${
                            val[0]?.description == 'Si' ? '' : 'invisible'
                        } col-sm-3 col-12`
                    }
                    if (mapValue.name == 'tire_image_spare') {
                        const val = alldata_all_dropdown.filter(
                            (e) => e.id == formikValues.spare_tire
                        )
                        mapValue.class = `${
                            val[0]?.description == 'Si'
                                ? ''
                                : 'disabledDropzone invisible'
                        } col-sm-3 col-12`
                    }
                }
            })

            if (formikValues?.user_id && formikValues?.user_id !== '') {
                let data = charityData.filter(
                    (item) => item.user_id == formikValues?.user_id
                )
                formikValues.first_name = charityData[0]?.emp_firstname
                formikValues.last_name = charityData[0]?.emp_lastname
                formikValues.email = charityData[0]?.emp_email

                if (data.length) {
                    setFilterCharity(data[0])
                } else {
                    setFilterCharity({})
                }
            }
            setReload(!reload)
            // setFieldData(tempMapData)
            setTimeout(() => {
                if (projectType === 'edit') {
                    if (tempMapData.length) {
                        // setSingleProject(single_project)
                    }
                }

                if (projectType === 'manifest') {
                    if (tempMapData.length) {
                        setSingleProject(singleManifest)
                        // if(single_manifest)
                    }
                }
            }, 2000)
        }
    }, [formikValues, single_project, singleManifest, props.data])

    useEffect(() => {
        if (
            single_project &&
            props?.data?.status === 'edit' &&
            single_project?.record?.id
        ) {
            setSingleProject({
                from: single_project?.from,
                record: {
                    ...single_project?.record,
                    brand: single_project?.record?.cigars_Marca
                        ? single_project?.record?.cigars_Marca
                        : single_project?.record?.brand,
                    vitola: single_project?.record?.cigars_VitoladeSalida
                        ? single_project?.record?.cigars_VitoladeSalida?.trimEnd() +
                          (single_project?.record?.cigars_SpecialReleaseName
                              ? ' ' +
                                single_project?.record?.cigars_SpecialReleaseName?.trimEnd()
                              : '')
                        : single_project?.record?.special_release_name
                        ? single_project?.record?.vitola?.trimEnd() +
                          ' ' +
                          single_project?.record?.special_release_name?.trimEnd()
                        : single_project?.record?.vitola?.trimEnd(),
                    special_release_name: single_project?.record
                        ?.cigars_SpecialReleaseName
                        ? single_project?.record?.cigars_SpecialReleaseName?.trimEnd()
                        : single_project?.record?.special_release_name,
                    packaging: single_project?.record?.cigars_Packaging
                        ? single_project?.record?.cigars_Packaging
                        : single_project?.record?.packaging,
                    year: single_project?.record?.cigars_Year
                        ? single_project?.record?.cigars_Year
                        : single_project?.record?.year,
                    current_number_of_cigars_in_box: single_project?.record
                        ?.cigars_NumberOfCigarsInBox
                        ? single_project?.record?.cigars_NumberOfCigarsInBox
                        : single_project?.record
                              ?.current_number_of_cigars_in_box,
                },
            })
        }
    }, [single_project, props.data])

    useEffect(() => {
        let manifest_value = {}
        if (Object.keys(single_manifest.record).length) {
            manifest_value = single_manifest
            manifest_value.record.qty = manifest_value?.record?.quantity || 0
            manifest_value.record.asin_id = manifest_value?.record?.asin || 0
            manifest_value.record.brand =
                manifest_value.record.manufacturer_name || ''
            manifest_value.record.desc_proc =
                manifest_value.record.description || ''

            manifest_value.record.bprice =
                manifest_value.record.cost_per_unit || 0
            setSingleManifest(manifest_value)
        }
    }, [single_manifest])

    useEffect(() => {
        const projectToShow = []
        if (all_auctions && all_auctions.records.length > 0) {
            all_auctions.records.map((lot) => {
                if (lot.market_status != 'closed')
                    projectToShow.push({ value: lot.id, show: lot.title })
            })
            setAllauctions(projectToShow)
        } else {
            setAllauctions(projectToShow)
        }
    }, [all_auctions])

    useEffect(() => {
        if (responseStatusProduct) {
            if (
                responseStatusProduct.status === 'success' &&
                responseStatusProduct.from === 'projectAction'
            ) {
                if (props.standalone) {
                    setIsLoading(false)
                    props.closeFunction(false)
                    randomVariable = Math.random()
                } else {
                    toggleFullScreenPopup(false)
                    randomVariable = Math.random()
                }
                const filterBody = {
                    filterRange: true,
                    search: 'within',
                    within: 'month',
                }
                getMainDashboardData(filterBody)
            }
            clearResponseProduct()
        }
    }, [responseStatusProduct])

    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    useEffect(() => {
        if (search_fetch_data && mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            if (search_fetch_data.from === 'employees') {
                if (search_fetch_data.records.length) {
                    setCharityData(search_fetch_data.records)
                    tempMapData.map((mapValue) => {
                        if (mapValue.name === 'user_id') {
                            mapValue.options = search_fetch_data.records.map(
                                (data) => {
                                    let busCategoryChanged = {}
                                    busCategoryChanged.show = data?.username
                                        ? data.username
                                        : data.emp_firstname + data.emp_lastname
                                    // data.emp_firstname + data.emp_lastname
                                    busCategoryChanged.value = data.id
                                    busCategoryChanged.email = data.email
                                    busCategoryChanged.first_name =
                                        data.emp_firstname
                                    busCategoryChanged.last_name =
                                        data.emp_lastname

                                    return busCategoryChanged
                                }
                            )
                        }
                    })
                } else {
                    setCharityData([])
                    tempMapData.map((mapValue) => {
                        if (mapValue.name === 'charity_id') {
                            mapValue.options = []
                        }
                    })
                }
            }
            setReload(!reload)
        }
    }, [search_fetch_data])

    const validationArray = Yup.object({
        asin: Yup.string().required('Required!'),
    })

    const validationHomeArray = Yup.object({
        home_depot: Yup.string().required('Required!'),
    })

    const validationXBarArray = Yup.object({
        x_barcode: Yup.string().required('Required!'),
    })

    const validationUpcArray = Yup.object({
        upc_id: Yup.number().required('Required!'),
    })

    const formikAsin = useFormik({
        initialValues: {
            user_id: user?.admin_id,
            asin: '',
            id: '',
            type: 'asin', // Don't Change Type
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            randomVariable = Math.random()
            setPluginType(values.type)
            values.id = values.asin

            retrieveProduct(values, randomVariable)
            formikHomeDepot.values.home_depot = ''
            formikUpc.values.upc_id = ''
        },
    })
    const formikHomeDepot = useFormik({
        initialValues: {
            user_id: user?.admin_id,
            home_depot: '',
        },
        validateOnBlur: false,
        validationSchema: validationHomeArray,
        onSubmit: (values) => {
            retrieveHomeDepot(values)
            formikAsin.values.asin = ''
            formikUpc.values.upc_id = ''
        },
    })

    const formikXBarCode = useFormik({
        initialValues: {
            user_id: user?.admin_id,
            x_barcode: '',
        },
        validateOnBlur: false,
        validationSchema: validationXBarArray,
        onSubmit: (values) => {
            retrieveXBarCode(values)
            formikAsin.values.asin = ''
            formikUpc.values.upc_id = ''
        },
    })

    const formikUpc = useFormik({
        initialValues: {
            upc_id: '',
            type: 'upc', // Don't Change Type
            id: '',
        },
        validateOnBlur: false,
        validationSchema: validationUpcArray,
        onSubmit: (values) => {
            randomVariable = Math.random()

            setPluginType(values.type)
            values.id = values.upc_id
            retrieveProduct(values, randomVariable)
            setIsLoading(true)
            formikAsin.values.asin = ''
            formikHomeDepot.values.home_depot = ''
        },
    })

    const categoryFilter = (value, fieldname) => {
        if (value) {
            setIsLoading(true)
            let arrayData = [...propsFieldValue]
            let filterValue = ''
            arrayData.map((data, index) => {
                if (data.type === 'select') {
                    if (value !== null) {
                        if (!data.diff_value) {
                            let idValue = {}
                            idValue = alldata_all_dropdown.filter(
                                (item) =>
                                    item.description === `${value}` &&
                                    item.variable === `${fieldname}` &&
                                    item.active == 1
                            )
                            if (idValue.length) {
                                let values = idValue[0]
                                filterValue = values.id
                            }
                        }
                    }
                }
            })
            if (filterValue !== '') {
                return filterValue
            } else {
                searchTableAction(
                    {
                        id: 0,
                        value: null,
                        description: value,
                        variable: fieldname,
                        table: 'data_all_dropdown',
                        active: 1,
                    },
                    false,
                    'updateDropdown'
                )
            }
        }
    }

    useEffect(() => {
        if (responseStatusSetting) {
            if (responseStatusSetting.status === 'success') {
                if (responseStatusSetting.from === 'updateDropdown') {
                    getGlobalVariable()
                    setTimeout(() => {
                        // setReload(!reload)
                        setUpdate(!update)
                    }, 2000)

                    // setReload(!reload)
                    clearResponseCommuncation()
                }
            }
        }
    }, [responseStatusSetting])

    const updateCount = (data) => {
        if (showPluginCount.length && showPluginCount.includes(data)) {
            if (pluginCountDetails && pluginCountDetails[data]) {
                let plugin = pluginCountDetails[data]

                let plusCount = parseInt(plugin.used, 10) + 1
                let maxCount = parseInt(plugin.limit, 10)
                let pluginValue = {
                    limit: maxCount,
                    used: plusCount,
                    balance: maxCount <= plusCount ? 0 : maxCount - plusCount,
                    enable: maxCount <= plusCount ? 0 : 1,
                    percent: (plusCount / maxCount) * 100,
                }
                // let newObj=pluginCountDetails

                setPluginCountDetails((ele) => {
                    let temp = { ...ele }
                    temp[data] = pluginValue
                    return temp
                })
            }
        }
    }

    useEffect(() => {
        if (
            all_products.from === randomVariable &&
            Object.keys(all_products.record).length
        ) {
            updateCount(pluginType)
            setAsinDetails(all_products)
            setAlert('Product Retrieved Successfullly', 'success')
            randomVariable = Math.random()
        } else if (all_products.from === randomVariable) {
            setAsinDetails({})
            setIsLoading(false)
            setAlert(all_products.message, 'error')
            randomVariable = Math.random()
        }
    }, [all_products])

    useEffect(() => {
        if (xbar_products?.record && Object.keys(xbar_products.record).length) {
            let categoryValue = xbar_products.record?.category
            let categoryChanged = ''
            if (categoryValue !== '') {
                categoryChanged = categoryFilter(categoryValue, 'category')
            } else {
                categoryChanged = ''
            }
            // let categoryValue = categoryFilter(all_products.record?.category, 'category')
            let asinTempValue = {
                record: {
                    // title: xbar_products.record?.title,
                    auction: 1,
                    shipping_enable: props?.defaultValues?.shipping_enable || 0,
                    local_pickup_check:
                        props?.defaultValues?.local_pickup_check || 0,
                    dimension_length:
                        xbar_products.record?.packageDimensions?.length,
                    dimension_width:
                        xbar_products.record?.packageDimensions?.width,
                    dimension_height:
                        xbar_products.record?.packageDimensions?.height,
                    weight_value:
                        xbar_products.record?.packageDimensions?.weight,
                    sku: xbar_products.record?.mpn,
                    brand: xbar_products.record?.brand,
                    upc: xbar_products.record?.upc,
                    category: categoryChanged,
                    uploadimages: xbar_products.record?.uploadimages,
                    auctiontype: 'live',
                    asin_price: xbar_products?.record?.lowestNewPrice || 0,
                    asin_id: xbar_products?.record?.asin || 0,
                    sprice: props?.defaultValues?.sprice || 0,
                    rprice: props?.defaultValues?.rprice || 0,
                    qty: props?.defaultValues?.qty || 0,
                    pick_up_details: props.configValues?.pick_up_details || '',
                    return_condition_details:
                        props.configValues?.return_condition_details || '',
                    payment_details: props.configValues?.payment_details || '',
                },
            }
            let mapData = []
            mapData = [...propsFieldValue]
            if (mapData.length) {
                mapData.map((data, index) => {
                    if (data.name === 'auctionid') {
                        data.options = allautiondetails ? allautiondetails : []
                    }
                })
            }
            let index = mapData.findIndex((e) => e.name === 'buynow')
            const array = {
                type: 'misc',
                content: [
                    <a
                        target="_blank"
                        onClick={viewTerms}
                        className="text-danger"
                    >
                        {`Check Price? - ${
                            xbar_products.record?.lowestNewPrice !== null
                                ? xbar_products.record?.lowestNewPrice
                                : '0'
                        }`}
                    </a>,
                ],
                class: 'col-12',
                show_order: 7,
            }
            let orderedArray = addAfter(mapData, index, array)
            setFieldData(orderedArray)
            setTimeout(() => {
                if (orderedArray.length) {
                    setAsinValue(asinTempValue)
                }
            }, 2000)
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 1500)
    }, [xbar_products, update])
    const splitVitola = (
        value,
        field1,
        field2,
        field3,
        field4,
        filterValue1,
        filterValue2,
        filterValue3,
        filterValue4,
        filtername1,
        filtername2
    ) => {
        const match = all_global_data?.records?.find((item) => {
            const combinedValue =
                (item[filtername1] || '') + ' ' + (item[filtername2] || '')
            const trimmed = combinedValue.trimEnd()
            return (
                trimmed === value &&
                item[field1].trimEnd() === filterValue1 &&
                item[field2].trimEnd() === filterValue2 &&
                item[field3].trimEnd() === filterValue3 &&
                item[field4].trimEnd() === filterValue4
            )
        })

        return match
    }

    useEffect(() => {
        if (asinDetails?.record && Object.keys(asinDetails.record).length) {
            let categoryValue = asinDetails.record?.category
            let categoryChanged = ''
            if (categoryValue !== '') {
                categoryChanged = categoryFilter(categoryValue, 'category')
            } else {
                categoryChanged = ''
            }
            // let categoryValue = categoryFilter(all_products.record?.category, 'category')
            let asinTempValue = {
                record: {
                    // title: asinDetails.record?.title,
                    auction: 1,
                    shipping_enable: props?.defaultValues?.shipping_enable || 0,
                    local_pickup_check:
                        props?.defaultValues?.local_pickup_check || 0,
                    dimension_length:
                        asinDetails.record?.packageDimensions?.length,
                    dimension_width:
                        asinDetails.record?.packageDimensions?.width,
                    dimension_height:
                        asinDetails.record?.packageDimensions?.height,
                    weight_value: asinDetails.record?.packageDimensions?.weight,
                    sku: asinDetails.record?.mpn,
                    brand: asinDetails.record?.brand,
                    upc: asinDetails.record?.upc,
                    category: categoryChanged,
                    uploadimages: asinDetails.record?.uploadimages,
                    auctiontype: 'live',
                    asin_price: asinDetails?.record?.lowestNewPrice || 0,
                    asin_id: asinDetails?.record?.asin || 0,
                    sprice: props?.defaultValues?.sprice || 0,
                    rprice: props?.defaultValues?.rprice || 0,
                    desc_proc:
                        asinDetails?.record?.prod_desc ||
                        asinDetails?.record?.title,
                    qty: props?.defaultValues?.qty
                        ? props?.defaultValues?.qty
                        : asinDetails?.record?.qty
                        ? asinDetails?.record?.qty
                        : 0,
                    pick_up_details: props.configValues?.pick_up_details || '',
                    return_condition_details:
                        props.configValues?.return_condition_details || '',
                    payment_details: props.configValues?.payment_details || '',
                },
            }
            let mapData = []
            mapData = [...propsFieldValue]
            if (mapData.length) {
                mapData.map((data, index) => {
                    if (data.name === 'auctionid') {
                        data.options = allautiondetails ? allautiondetails : []
                    }
                })
            }
            let index = mapData.findIndex((e) => e.name === 'buynow')
            const array = {
                type: 'misc',
                content: [
                    <a
                        target="_blank"
                        onClick={viewTerms}
                        className="text-danger"
                    >
                        {`Check Price? - ${
                            asinDetails.record?.lowestNewPrice !== null
                                ? asinDetails.record?.lowestNewPrice
                                : '0'
                        }`}
                    </a>,
                ],
                class: 'col-12',
                show_order: 7,
            }
            let orderedArray = addAfter(mapData, index, array)
            setFieldData(orderedArray)
            setTimeout(() => {
                if (orderedArray.length) {
                    setAsinValue(asinTempValue)
                }
            }, 2000)
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 1500)
    }, [asinDetails, update])

    const viewHomeDepot = (data) => {
        window.open(`${data}`)
    }

    const viewUpc = (data) => {
        if (data === '') {
        } else {
            window.open(`${data}`)
        }
    }

    const viewTerms = () => {
        window.open(
            `https://www.amazon.com/dp/${formikAsin.values.asin}?%2Ftag=auction0f2-20&th=1`
        )
    }
    const addAfter = (array, index, newItem) => {
        return [...array.slice(0, index), newItem, ...array.slice(index)]
    }

    useEffect(() => {
        let mapData = [...propsFieldValue]
        if (mapData.length) {
            mapData.map((data, index) => {
                if (data.name === 'auctionid') {
                    data.options = allautiondetails
                        ? [
                              {
                                  id: 0,
                                  value: 0,
                                  show: 'Standard 72 Hour Auction',
                              },
                              ...allautiondetails,
                          ]
                        : []
                }
            })
            setFieldData(mapData)
            setReload(!reload)
            setTimeout(() => {
                setIsLoading(false)
            }, 2000)
        }
    }, [propsFieldValue, props.data, allautiondetails])

    const resetFormikAsin = () => {
        formikAsin.values.asin = ''
    }

    const resetFormikHome = () => {
        formikHomeDepot.values.home_depot = ''
    }

    const resetFormikXBar = () => {
        formikXBarCode.values.x_barcode = ''
    }

    const resetFormikUpc = () => {
        formikUpc.values.upc_id = ''
    }

    const submitFunction = (data, updatedFormikValues) => {
        const value = updatedFormikValues
        if (data) {
            value.market_status = data
        }
        /* It is for duplicate lot posting */
        if (props?.data?.status === 'duplicate') {
            value.id = 0
            value.market_status = 'draft'
        }

        if (props?.data?.status === 'manifest') {
            value.id = 0
            value.market_status = 'draft'
        }

        if (value?.sale_type) {
            if (value.sale_type === 'auction') {
                value.auctiontype = 'live'
            } else if (value.sale_type === 'sealed') {
                value.auctiontype = 'sealed'
            } else if (value.sale_type === 'sealed_rank') {
                value.auctiontype = 'sealed'
            }
        }

        if (value.reverseauction) {
            value.auctiontype = 'reverse'
        } else {
            value.auctiontype = value.auctiontype || 'live'
        }

        if (props.userId) {
            if (props.userId !== null) {
                value.user_id = props.userId
            }
        }
        if (Object.keys(filterCharity).length) {
            value.user_id = filterCharity?.id
            value.email = filterCharity?.email
            value.first_name = filterCharity?.first_name
            value.last_name = filterCharity?.last_name
        }
        if (value.slot_date) {
            value.slot_date = dateFormatFunction(value.slot_date)
        }
        if (props.dynamicFieldTable) {
            value.table = props.dynamicFieldTable
        }

        if (props.shipStation) {
            if (
                props.carrierCode &&
                props.serviceCode &&
                value.shipping_check &&
                !props.dynamicLocation
            ) {
                value.station_service_code = props.serviceCode
                value.station_carrier_code = props.carrierCode
                value.origin_first_name = props.default_address[0] || 'Kirpa'
                value.origin_last_name =
                    props.default_address[1] || 'Unlimited LLC'
                value.origin_phone = props.default_address[2] || ''
                value.origin_email = props.default_address[3] || ''
                value.origin_address1 =
                    props.default_address[4] ||
                    '1802 Industrial Blvd Suite 1010'
                value.origin_country = 'US'
                value.origin_state = props.default_address[5] || 'TX'
                value.origin_city = props.default_address[6] || 'Colleyville'
                value.origin_zip = props.default_address[7] || '76034'
                value.shipping = 'shipStation'
                value.station_package_code = props.station_package_code
                    ? props.station_package_code
                    : ''
                value.station_warehouse = props.station_warehouse
                    ? props.station_warehouse
                    : ''
            } else if (
                props.carrierCode &&
                props.serviceCode &&
                value.shipping_check &&
                props.dynamicLocation &&
                value.lot_location
            ) {
                let filteredLocation = allLocations.filter(
                    (item) => item.id == value.lot_location
                )

                value.station_service_code = props.serviceCode
                value.station_carrier_code = props.carrierCode
                value.origin_first_name = props.default_address[0] || 'Kirpa'
                value.origin_last_name =
                    props.default_address[1] || 'Unlimited LLC'
                value.origin_phone = props.default_address[2] || ''
                value.origin_email = props.default_address[3] || ''
                value.origin_address1 = filteredLocation.length
                    ? filteredLocation[0].address
                    : '1802 Industrial Blvd Suite 1010'
                value.origin_country = 'US'
                value.origin_state = filteredLocation.length
                    ? filteredLocation[0].state
                    : 'TX'
                value.origin_city = filteredLocation.length
                    ? filteredLocation[0].city
                    : 'Colleyville'
                value.origin_zip = filteredLocation.length
                    ? filteredLocation[0].zipCode
                    : '76034'
                value.shipping = 'shipStation'
                value.station_package_code = props.station_package_code
                    ? props.station_package_code
                    : ''
                value.station_warehouse = props.station_warehouse
                    ? props.station_warehouse
                    : ''
            }
        }
        if (props.toggleAuctionAndBuynow) {
            if (value.auction) {
                value.bprice = ''
            } else {
                value.sprice = ''
                value.rprice = ''
            }
        }
        if (props?.validate) {
            props.validateFunc(value)
        } else {
            if (!props.loading) {
                setIsLoading(true)
            }

            // if (global?.location_equal_location_id) {
            //     if (value.location) {
            //         value.location_id = parseInt(value.location, 10)
            //     }
            // }
            if (singleProject?.record) {
                value.first_name =
                    singleProject?.record?.as_employees_emp_firstname
                value.username = singleProject?.record?.as_employees_username
                value.last_name =
                    singleProject?.record?.as_employees_emp_lastname
                value.email = singleProject?.record?.as_employees_emp_email
            }

            let vitolSplitValue = splitVitola(
                value?.vitola,
                'Maker',
                'MakerCountry',
                'CigarCountry',
                'Marca',
                value?.maker,
                value?.maker_country,
                value?.cigar_country,
                value?.brand,
                'VitoladeSalida',
                'SpecialReleaseName'
            )

            if (vitolSplitValue) {
                value.vitola = vitolSplitValue['VitoladeSalida'].trimEnd()
                value.special_release_name =
                    vitolSplitValue['SpecialReleaseName'].trimEnd()
            }

            projectAction(value)
        }
    }

    const formSubmit = (value, data) => {
        const updatedFormikValues = {
            ...value,
            market_status: data,
        }

        setFormikValues(updatedFormikValues)
        submitFunction(data, updatedFormikValues)
    }

    const cancelSubmit = () => {
        setIsLoading(false)
        if (props.closeFunction) {
            props.closeFunction()
        } else {
            toggleFullScreenPopup(false, '', 0)
        }

        randomVariable = Math.random()
    }

    useEffect(() => {
        if (data?.status) {
            if (props.getAuction) {
                getAllAuctions({
                    page: 1,
                    limit: 50,
                    order: '',
                    orderby: '',
                    filters: {
                        market_status: {
                            value: 'open',
                            type: 'in',
                            field: 'ac.market_status',
                        },
                    },
                })
            }
        }
    }, [data, props.getAuction])

    const closeFunction = () => {
        setIsLoading(false)
        toggleFullScreenPopup(false, '', 0)
        randomVariable = Math.random()
    }

    useEffect(() => {
        setIsLoading(true)
        if (data?.status !== 'edit') {
            if (data?.status === 'new') {
                resetFormikAsin()
                resetFormikHome()
                setFormikValues({
                    ...formikValues,
                    id: 0,
                })
            }
        }
    }, [data?.id])

    useEffect(() => {
        const buttonDataTemp = []
        if (data && data?.status === 'duplicate') {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: 'Duplicate',
                additionalValue: 'open',
            })
        }
        if (data && data?.status === 'manifest') {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: 'Save as Draft',
                additionalValue: 'draft',
            })
        } else if (data && data?.status === 'use') {
            buttonDataTemp.push({
                type: props.draftValidate ? 'submit' : 'button',
                style: 'secondary',
                label: props.draftValidate ? 'submit' : 'save as draft',
                additionalValue: 'draft',
            })
            if (!props.noSubmitBtn) {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'submit',
                    additionalValue: 'open',
                })
            }
        } else {
            if (formikValues.id && singleProject?.record?.id) {
                if (singleProject?.record?.market_status === 'draft') {
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: 'Update',
                        additionalValue: '',
                    })
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: 'Approve',
                        additionalValue: 'open',
                    })
                }
                if (singleProject?.record?.market_status === 'relisted') {
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: 'Update',
                        additionalValue: '',
                    })
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: 'Approve',
                        additionalValue: 'open',
                    })
                }

                if (
                    singleProject?.record?.market_status === 'open' &&
                    !props.noUpdateBtn
                ) {
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: 'Update',
                        additionalValue: 'open',
                    })
                }
            } else {
                buttonDataTemp.push({
                    type: props.draftValidate ? 'submit' : 'button',
                    style: 'secondary',
                    label: 'save as draft',
                    additionalValue: 'draft',
                })
                if (!props.noSubmitBtn) {
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: 'submit',
                        additionalValue: 'open',
                    })
                }
            }
        }

        setButtonData(buttonDataTemp)
    }, [formikValues.id, data?.status])
    const makePaymentFn = (data) => {
        handleRedirectInternal(history, `billing/${data ? data : 'all'}/0`)
    }
    const ShowBalance = ({ data }) => {
        return data ? (
            <div className="customProgress">
                <LinearProgress
                    variant="determinate"
                    value={data.percent ? data.percent : 0}
                />

                <p className="cpLeft">{`${data.balance} of ${data.limit} Left `}</p>
            </div>
        ) : null
    }

    return props.standalone ? (
        <>
            {isLoading ? (
                <div className="fspLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <>
                    <BaseActionPage
                        arrayValue={fieldData}
                        data={props.data}
                        reloadData={props?.reloadData}
                        additionalFormikUpdate={additionalFormikUpdate}
                        editFunction={getSingleProject}
                        editManifestFunction={getSingleManifest}
                        editValue={singleProject}
                        handleMapDataValue={handleMapDataValue}
                        actionFunction={formSubmit}
                        cancelFunction={cancelSubmit}
                        buttonAction={buttonData}
                        permission={props.permission}
                        customValidation={customValidation}
                        draftValidation={props.draftValidation}
                        customInitialValues={customInitialValues}
                        showasin={false}
                        homeDepot={false}
                        xBarCode={false}
                        all_products={asinValue}
                        setrprice={props.setrprice}
                        customDynamicInput={
                            props.customDynamicInput
                                ? props.customDynamicInput
                                : false
                        }
                        customInBetween={true}
                        dynamicFieldTable={props.dynamicFieldTable}
                        isDelete={props.isDelete}
                        validationPopup={props.validationPopup}
                        template_GetSingleValue={template_GetSingleValue}
                        template_SingleValue={template_SingleValue}
                    />
                </>
            )}
        </>
    ) : (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? props.addModaltitle
                        ? props.addModaltitle
                        : t('ADD NEW LISTING')
                    : data?.status === 'duplicate'
                    ? t('Edit Duplicate Lot')
                    : props.editModaltitle
                    ? props.editModaltitle
                    : t(`Edit Listing`)
            }
            open={
                data.status === 'new' ||
                data.status === 'manifest' ||
                data.status === 'edit' ||
                data.status === 'duplicate' ||
                data.status === 'use'
                    ? data.popup
                    : false
            }
            handleClose={() => {
                closeFunction()
            }}
        >
            <div className="addUserModal addListing">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <BaseActionPage
                                arrayValue={fieldData}
                                data={props.data}
                                additionalFormikUpdate={additionalFormikUpdate}
                                reloadData={props?.reloadData}
                                editFunction={getSingleProject}
                                editManifestFunction={getSingleManifest}
                                editValue={singleProject}
                                handleMapDataValue={handleMapDataValue}
                                actionFunction={formSubmit}
                                cancelFunction={cancelSubmit}
                                permission={props.permission}
                                buttonAction={buttonData}
                                draftValidation={props.draftValidation}
                                customValidation={customValidation}
                                customInitialValues={customInitialValues}
                                showasin={false}
                                homeDepot={false}
                                xBarCode={false}
                                all_products={asinValue}
                                template_SingleValue={template_SingleValue}
                                template_GetSingleValue={
                                    template_GetSingleValue
                                }
                                setrprice={props.setrprice}
                                customDynamicInput={
                                    props.customDynamicInput
                                        ? props.customDynamicInput
                                        : false
                                }
                                customInBetween={true}
                                dynamicFieldTable={props.dynamicFieldTable}
                                isDelete={props.isDelete}
                                validationPopup={props.validationPopup}
                                // mapDataValue={mapDataValue}
                                // resetMapData={resetMapData}
                                // setResetMapData={setResetMapData}
                            />

                            {/* </form> */}
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default ProductFieldsView
